import { useAppContext } from '@/provider/contexts';
import { useEffect, useMemo } from 'react';
import { Box, CircularProgress } from '@mui/material';
import '@/styles/pages/StoreMgmt/layout/StoreLayoutPage.scss';
import { ViewComfyAlt } from '@mui/icons-material';
import BasePaper from '@/components/ui/BasePaper';
import BaseTitle from '@/components/ui/BaseTitle';
import NoStoreSelectionBlock from '@/components/store/NoStoreSelectionBlock';
import GetStartPage from './GetStartPage';
import TabLayouts from '@/components/layout/TabLayouts';
import { useLayoutState } from '@/provider/layouts/layoutContext';
import { useLayoutUtils } from '@/hooks/layouts/useLayoutUtils';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

export default function StoreLayoutPage() {
    const { manageStoreId } = useAppContext();
    const { state } = useLayoutState();
    const { fetchStoreDetail, fetchCategories } = useLayoutUtils();
    const { t } = useTranslation('common');

    const titleText = useMemo(() => {
        const { lp_name, lp_version } = state.packageInfo || {};
        if (state.loadings.layout) return t('Store Layout');
        if (lp_name) {
            return t('Store Layout「{{name}} - v{{version}}」', {
                name: lp_name,
                version: lp_version,
            });
        }
        return t('Store Layout');
    }, [state.packageInfo, state.loadings.layout, t]);

    useEffect(() => {
        fetchCategories();
    }, []);

    useEffect(() => {
        fetchStoreDetail();
    }, [fetchStoreDetail]);

    return (
        <>
            <BasePaper isFullHeight={false}>
                <BaseTitle
                    icon={
                        <Box sx={{ pt: '3px' }}>
                            <ViewComfyAlt />
                        </Box>
                    }
                    title={titleText}
                />
                {manageStoreId ? (
                    <>
                        {state.loadings.layout || state.loadings.category || isEmpty(state.packageInfo) ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', py: 3, alignItems: 'center' }}>
                                <CircularProgress size={50} />
                            </Box>
                        ) : (
                            <>{state.packageInfo.has_package ? <TabLayouts viewMode /> : <GetStartPage />}</>
                        )}
                    </>
                ) : (
                    <NoStoreSelectionBlock />
                )}
            </BasePaper>
        </>
    );
}
